module.exports = __webpack_public_path__ + "img/bnr-today.35a7a349.jpg";